/*
  links:
    AWS Cognito Password Regex - Specific to AWS Cognito [duplicate]
    https://stackoverflow.com/questions/58767980/aws-cognito-password-regex-specific-to-aws-cognito
*/
import React, { useState } from 'react'
import { Field } from 'formik'
import { Typography, Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { ClickAwayListener } from '@mui/material'

import TextField from 'components/Common/TextField'
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete'

const AddressItem = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '100%',
  zIndex: 100,
  backgroundColor: theme.palette.background.white,
  overflowY: 'auto',
  maxHeight: 220,
  fontSize: '14px',
  top: 80,
  borderRadius: '5px',
}))

const sx = {
  root: {
    position: 'relative',
  }
};

const AddressFields = ({ setFieldValue, initValues, disabled, borderLess }) => {

  const [initialValues, setInitialValues] = useState(initValues)
  const [open, setOpen] = useState(false)

  const preFillAddress = (suggestion, setValue) => {
    geocodeByAddress(suggestion.description)
      .then(results => {
        let { address_components, geometry } = results[0]
        const lat = geometry.location.lat()
        const lon = geometry.location.lng()
        const address = suggestion.formattedSuggestion.secondaryText.split(', ')
        const country = address.find(el => el.length === 3)
        const city = address.filter(el => el !== 'USA' && el.length > 2)[0]
        const state = address.filter(el => el.length === 2)[0]
        address_components.filter(el =>
          el.types[0] === 'postal_code' ? setValue('zip', el.long_name) : setValue('zip', ''),
        )
        setValue('city', city)
        setValue('state', state)
        setValue('address', suggestion.formattedSuggestion.mainText)
        setValue('country', country)
        setValue('lat', lat)
        setValue('lon', lon)
      })
      .catch(error => console.error('Error', error))
  }

  const onAddressChange = address => {
    setOpen(true)
    setInitialValues({
      ...initialValues,
      address: address,
    })
  }
  const handleClickAway = () => setOpen(false)

  return (
    <Box sx={sx.root}>
      <PlacesAutocomplete value={initialValues.address} onChange={onAddressChange}>
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
          return (
            <div>
              <Field name={'address'}>
                {({ field, meta }) => {
                  return (
                    <TextField
                      // required
                      borderLess={borderLess}
                      autoComplete="off"
                      {...field}
                      onChange={e => {
                        getInputProps().onChange(e)
                        setFieldValue('address', e.target.value)
                      }}
                      label={'Address'}
                      fullWidth
                      error={Boolean(meta.error)}
                      helperText={meta.error}
                      disabled={disabled}
                    />
                  )
                }}
              </Field>
              {loading && (
                <Typography color="primary" variant="caption">
                  Loading...
                </Typography>
              )}
              <ClickAwayListener onClickAway={handleClickAway}>
                <Box>
                  {open ? (
                    <AddressItem>
                      {suggestions.map((suggestion, index) => (
                        <Box
                          key={index}
                          onClick={() => preFillAddress(suggestion, setFieldValue)}
                          sx={{
                            padding: '8px',
                            // borderBottom: '1px solid #CCCBD9',
                            cursor: 'pointer',
                            margin: "5px 15px",
                            "&:hover": {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                              borderRadius: "5px"
                            }
                          }}
                        >
                          <Typography {...getSuggestionItemProps(suggestion)} variant="body2b" color="primary">
                            {suggestion.description}
                          </Typography>
                        </Box>
                      ))}
                    </AddressItem>
                  ) : null}
                </Box>
              </ClickAwayListener>
            </div>
          )
        }}
      </PlacesAutocomplete>
    </Box>
  )
}

export default AddressFields
